<template>
  <div
    class="fs-the-navbar text-base bg-white sticky top-0 z-20 border-b border-new-gray-300 antialiased xl:px-10"
  >
    <div class="flex justify-between items-center py-2 h-14 px-4">
      <!-- 左區 start-->
      <div class="flex items-center xl:justify-start xl:flex-1">
        <!-- Logo start-->
        <img
          src="@/assets/images/logo_web.svg"
          alt="fundswap-logo-image"
          class="w-[120px] sm:w-auto hover:cursor-pointer"
          @click="goWordPressIndex"
        />
        <!-- Logo end-->

        <!-- 主Nav start -->
        <nav class="hidden px-8 xl:flex">
          <a
            v-for="(nav, index) in navs"
            :key="'nav' + index"
            class="relative group text-new-gray-700 pr-6 py-4 last:pr-0 hover:text-new-primary-400 flex items-center whitespace-nowrap cursor-pointer"
          >
            <div class="font-medium">
              {{ nav.title }}
            </div>
            <div
              v-if="nav.suffix"
              class="text-sm transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
            >
              {{ nav.suffix }}
            </div>
            <div
              class="absolute top-[56px] -left-3 hidden bg-white whitespace-nowrap p-6 shadow z-50 group-hover:flex cursor-default"
            >
              <div
                v-for="(menu, menuIndex) in nav.menus"
                :key="'menu' + menuIndex"
                :class="[
                  'px-6 border-r border-new-gray-200 first:pl-0 last:pr-0 last:border-none',
                ]"
              >
                <a
                  v-if="menu.title"
                  :href="menu.link"
                  :target="menu.target"
                  :class="[
                    'text-new-gray-800 font-bold mb-4 inline-block',
                    menu.link ? 'hover:text-new-primary-400' : 'cursor-default',
                  ]"
                >
                  {{ menu.title }}
                </a>
                <div
                  :class="[
                    'grid gap-x-6 gap-y-4',
                    { 'grid-rows-4 grid-flow-col': menu.subMenus.length > 4 },
                  ]"
                >
                  <a
                    v-for="(subMenus, subMenuIndex) in menu.subMenus"
                    :key="'subMenus' + subMenuIndex"
                    :href="subMenus.link"
                    :target="subMenus.target"
                    :class="[
                      'text-sm text-new-gray-700 hover:text-new-primary-400 no-underline group',
                      {
                        'flex items-center':
                          subMenus.iconName || subMenus.suffix,
                      },
                    ]"
                  >
                    <div v-if="subMenus.iconName" class="w-5 mr-1">
                      <!-- 左方icon for 更多-->
                      <div v-if="subMenus.iconName === 'ellipsis-solid'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="22"
                          width="22"
                          viewBox="0 0 512 512"
                          :class="[
                            'fill-new-gray-700 mr-1 group-hover:fill-new-primary-400',
                          ]"
                        >
                          <path
                            fill="currentColor"
                            d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                          />
                        </svg>
                      </div>

                      <!-- 左方icon for 其他-->
                      <img
                        v-else
                        :src="
                          require(`@/assets/images/${subMenus.iconName}.svg`)
                        "
                        :alt="subMenus.iconName"
                        class="w-full"
                      />
                    </div>

                    <div class="flex justify-start items-center">
                      <img
                        src="@/assets/images/devil.svg"
                        v-if="subMenus.icon"
                        class="mt-[1px] mr-2"
                        alt="devil"
                      />
                      <div :class="subMenus.textColor">
                        {{ subMenus.label }}
                      </div>
                    </div>
                    <div
                      v-if="subMenus.suffix"
                      class="text-sm transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
                    >
                      {{ subMenus.suffix }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </a>
        </nav>
        <!-- 主Nav end -->

        <!-- 搜尋功能 start-->
        <div class="hidden xl:flex xl:flex-1 xl:max-w-[340px]">
          <slot></slot>
        </div>
        <!-- 搜尋功能 end-->
      </div>
      <!-- 左區 end-->

      <!-- 搜尋功能 start-->
      <div class="xl:hidden sm:ml-[-110px] flex-1 max-w-[340px]">
        <slot></slot>
      </div>
      <!-- 搜尋功能 end-->

      <!-- 右區 start-->
      <div>
        <!-- 副Nav start -->
        <nav class="hidden xl:flex">
          <a
            v-for="(subNav, index) in subNavs"
            :key="'subNav' + index"
            class="relative group text-new-gray-700 pr-6 py-4 first:ml-6 hover:text-new-primary-400 flex items-center whitespace-nowrap cursor-pointer"
          >
            <div
              v-if="subNav.title === '帳戶相關' && isLoggedIn"
              class="relative group"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C4.47581 0 0 4.47581 0 10C0 15.5242 4.47581 20 10 20C15.5242 20 20 15.5242 20 10C20 4.47581 15.5242 0 10 0ZM10 3.87097C11.9597 3.87097 13.5484 5.45968 13.5484 7.41935C13.5484 9.37903 11.9597 10.9677 10 10.9677C8.04032 10.9677 6.45161 9.37903 6.45161 7.41935C6.45161 5.45968 8.04032 3.87097 10 3.87097ZM10 17.7419C7.63306 17.7419 5.5121 16.6694 4.09274 14.9919C4.85081 13.5645 6.33468 12.5806 8.06452 12.5806C8.16129 12.5806 8.25806 12.5968 8.35081 12.625C8.875 12.7944 9.42339 12.9032 10 12.9032C10.5766 12.9032 11.129 12.7944 11.6492 12.625C11.7419 12.5968 11.8387 12.5806 11.9355 12.5806C13.6653 12.5806 15.1492 13.5645 15.9073 14.9919C14.4879 16.6694 12.3669 17.7419 10 17.7419Z"
                  fill="#333333"
                />
              </svg>
              <!-- 通知紅點 -->
              <div
                v-if="notificationCount > 0"
                class="absolute -top-1 left-3.5 h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 flex justify-center items-center group-hover:hidden"
              >
                {{ notificationCount }}
              </div>
              <!-- 通知紅點 -->
            </div>
            <template
              v-else-if="
                subNav.title === '優惠' ||
                subNav.title === '庫存/紀錄' ||
                subNav.title === '信託分戶帳(錢包)'
              "
            >
              <div class="font-medium">{{ subNav.title }}</div>
              <div
                v-if="subNav.suffix"
                class="text-sm transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
              >
                {{ subNav.suffix }}
              </div>
            </template>
            <template v-else-if="isLoggedIn">
              <div class="font-medium">{{ subNav.title }}</div>
              <div
                v-if="subNav.suffix"
                class="text-sm font-normal transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
              >
                {{ subNav.suffix }}
              </div>
            </template>
            <div
              class="absolute top-[56px] right-0 hidden bg-white whitespace-nowrap p-6 shadow z-50 group-hover:flex cursor-default"
            >
              <div
                v-for="(menu, menuIndex) in subNav.menus"
                :key="'menu' + menuIndex"
                :class="[
                  'px-6 border-r border-new-gray-200 first:pl-0 last:pr-0 last:border-none',
                ]"
              >
                <a
                  v-if="menu.title"
                  :href="menu.link"
                  :class="[
                    'text-new-gray-800 font-bold mb-4 inline-block',
                    menu.link ? 'hover:text-new-primary-400' : 'cursor-default',
                  ]"
                >
                  {{ menu.title }}
                </a>
                <div
                  :class="[
                    'grid gap-x-6 gap-y-4',
                    { 'grid-rows-4 grid-flow-col': menu.subMenus.length > 4 },
                  ]"
                >
                  <a
                    v-for="(subMenus, subMenuIndex) in menu.subMenus"
                    :key="'subMenus' + subMenuIndex"
                    :href="
                      subMenus.isHtml && !subMenus.link
                        ? 'javascript:void(0)'
                        : subMenus.link
                    "
                    :target="subMenus.target"
                    :class="[
                      'text-sm text-new-gray-700 hover:text-new-primary-400 no-underline group',
                      {
                        'flex items-center':
                          subMenus.iconName || notificationCount > 0,
                      },
                    ]"
                    @click="subMenus.isHtml ? openForeignAlert() : ''"
                  >
                    <div v-if="subMenus.isHtml">
                      <!-- label 只來自本元件內寫死的字串（開啟外幣功能＋foreignAccountStatusDesc 的三種固定標記），不含外部輸入 -->
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <div v-html="subMenus.label"></div>
                    </div>
                    <template v-else>
                      <!-- 左方icon for 更多-->
                      <div
                        v-if="
                          subMenus.iconName &&
                          subMenus.iconName === 'ellipsis-solid'
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="22"
                          width="22"
                          viewBox="0 0 512 512"
                          :class="[
                            'fill-new-gray-700 mr-1 group-hover:fill-new-primary-400',
                          ]"
                        >
                          <path
                            fill="currentColor"
                            d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                          />
                        </svg>
                      </div>

                      <!-- 左方icon for 其他-->
                      <img
                        v-if="
                          subMenus.iconName &&
                          subMenus.iconName !== 'ellipsis-solid'
                        "
                        :src="
                          require(`@/assets/images/${subMenus.iconName}.svg`)
                        "
                        :alt="subMenus.iconName"
                        class="mr-1"
                      />

                      <span
                        class="flex items-center"
                        :class="subMenus.textColor"
                      >
                        {{ subMenus.label }}
                        <div
                          v-if="subMenus.suffix"
                          class="text-sm transform mt-0.5 scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 pb-0.5"
                        >
                          {{ subMenus.suffix }}
                        </div>
                      </span>
                      <!-- 通知紅點 -->
                      <span
                        v-if="
                          subMenus.label === '通知中心' && notificationCount > 0
                        "
                        class="h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 ml-1 flex justify-center items-center"
                      >
                        {{ notificationCount }}
                      </span>
                      <!-- 通知紅點 -->
                    </template>
                  </a>
                </div>
              </div>
            </div>
          </a>
          <!-- 導頁Buttons start-->
          <div class="flex justify-center items-center">
            <button
              v-if="isLoggedIn"
              class="bg-white text-new-gray-800 font-medium ring-1 ring-new-gray-300 px-4 py-2 rounded whitespace-nowrap hover:cursor-pointer focus:outline-none"
              @click="toLogout"
            >
              登出
            </button>
            <button
              v-if="!isLoggedIn"
              class="bg-white text-new-gray-800 font-medium border border-new-gray-300 px-4 py-2 rounded mr-2 focus:outline-none"
              @click="toLoginPage"
            >
              登入
            </button>
            <button
              v-if="!isLoggedIn"
              class="text-white font-medium bg-new-primary-500 px-4 py-2 rounded focus:outline-none hover:cursor-pointer"
              @click="toRegisterPage"
            >
              開戶(含 TISA)
            </button>
          </div>
          <!-- 導頁Buttons end-->
        </nav>
        <!-- 副Nav end -->

        <!-- 漢堡按鈕 start-->
        <button
          class="relative xl:hidden bg-white w-5 h-9 focus:outline-none"
          @click="isOpenMenu = !isOpenMenu"
        >
          <div
            class="block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
          >
            <span
              aria-hidden="true"
              class="block absolute h-[3px] w-5 bg-new-gray-700 transform transition duration-500 ease-in-out rounded-[1px]"
              :class="{
                'rotate-45': isOpenMenu,
                'translate-y-[-0.4rem]': !isOpenMenu,
              }"
            ></span>
            <span
              aria-hidden="true"
              class="block absolute h-[3px] w-5 bg-new-gray-700 transform transition duration-500 ease-in-out rounded-[1px]"
              :class="{ 'opacity-0': isOpenMenu }"
            ></span>
            <span
              aria-hidden="true"
              class="block absolute h-[3px] w-5 bg-new-gray-700 transform transition duration-500 ease-in-out rounded-[1px]"
              :class="{
                '-rotate-45': isOpenMenu,
                'translate-y-[0.4rem]': !isOpenMenu,
              }"
            ></span>
          </div>
          <!-- 通知紅點 -->
          <div
            v-if="notificationCount > 0"
            class="absolute top-0 left-3 h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 flex justify-center items-center group-hover:hidden"
          >
            {{ notificationCount }}
          </div>
          <!-- 通知紅點 -->
        </button>
        <!-- 漢堡按鈕 end-->
      </div>
      <!-- 右區 end-->
    </div>

    <!-- Mobile Navs Model start -->
    <div v-if="isOpenMenu" class="fixed top-0 left-0 xl:hidden">
      <div
        v-if="isOpenMenu"
        :class="[
          'w-full h-full fixed z-50 flex justify-end bg-black bg-opacity-70',
        ]"
        @click.self="isOpenMenu = false"
      ></div>
      <div class="flex">
        <button
          class="relative xl:hidden w-5 h-9 focus:outline-none text-white z-50 top-4 left-4"
          @click="(isOpenMenu = !isOpenMenu), (isShowContent = false)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M13.7909 10L19.4767 4.3142C20.1744 3.61648 20.1744 2.48523 19.4767 1.78693L18.2131 0.523295C17.5153 -0.174432 16.3841 -0.174432 15.6858 0.523295L10 6.20909L4.3142 0.523295C3.61648 -0.174432 2.48523 -0.174432 1.78693 0.523295L0.523295 1.78693C-0.174432 2.48466 -0.174432 3.61591 0.523295 4.3142L6.20909 10L0.523295 15.6858C-0.174432 16.3835 -0.174432 17.5148 0.523295 18.2131L1.78693 19.4767C2.48466 20.1744 3.61648 20.1744 4.3142 19.4767L10 13.7909L15.6858 19.4767C16.3835 20.1744 17.5153 20.1744 18.2131 19.4767L19.4767 18.2131C20.1744 17.5153 20.1744 16.3841 19.4767 15.6858L13.7909 10Z"
              fill="currentColor"
            />
          </svg>
        </button>

        <div
          :class="[
            'bg-white h-full w-80 transition-all duration-300 fixed z-50 overflow-auto',
            isOpenMenu ? 'right-0' : '-right-80',
          ]"
        >
          <div
            class="flex justify-end items-center px-4 py-2.5 border-b bg-white sticky top-0 z-50"
          >
            <a
              class="bg-white text-new-gray-800 font-medium rounded hover:cursor-pointer focus:outline-none"
              href="/trade/member-center/"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 640 640"
              >
                <path
                  fill="currentColor"
                  d="M463 448.2c-22.1-38.4-63.6-64.2-111-64.2h-64c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8M64 320C64 178.6 178.6 64 320 64s256 114.6 256 256s-114.6 256-256 256S64 461.4 64 320m256 16c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72s32.2 72 72 72"
                />
              </svg>
            </a>
            <!-- <button
              v-if="isLoggedIn"
              class="
                bg-white
                text-new-gray-800
                font-medium
                ring-1 ring-new-gray-300
                px-4
                py-[7px]
                rounded
                mr-4
                hover:cursor-pointer
                focus:outline-none
              "
              @click="toLogout"
            >
              登出
            </button>
            <button
              v-if="!isLoggedIn"
              class="
                bg-white
                text-new-gray-800
                font-medium
                ring-1 ring-new-gray-300
                px-4
                py-[7px]
                rounded
                mr-4
                hover:cursor-pointer
                focus:outline-none
              "
              @click="toLoginPage"
            >
              登入
            </button>
            <button
              v-if="!isLoggedIn"
              class="text-white font-medium bg-new-primary-500 px-4 py-2 rounded mr-4 focus:outline-none"
              @click="toRegisterPage"
            >
              開戶(含 TISA)
            </button> -->
          </div>

          <nav class="flex flex-col pb-40">
            <a
              v-for="(mobileNav, idx) in mobileNavs"
              :key="'mobileNavs' + idx"
              @click="toggle(idx)"
            >
              <div
                class="flex justify-between items-center text-new-gray-800 font-medium p-4"
              >
                <div
                  :class="[
                    'flex items-center leading-none',
                    {
                      'text-new-primary-600':
                        currentMenuIndex === idx && isShowContent,
                    },
                  ]"
                >
                  {{
                    mobileNav.title === "帳戶相關"
                      ? "會員/基金追蹤"
                      : mobileNav.title
                  }}
                  <div
                    v-if="mobileNav.suffix"
                    class="text-sm font-normal transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
                  >
                    {{ mobileNav.suffix }}
                  </div>
                  <!-- 通知紅點 -->
                  <div
                    v-if="
                      mobileNav.title === '帳戶相關' &&
                      !(currentMenuIndex === idx && isShowContent) &&
                      notificationCount > 0
                    "
                    class="h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 ml-2 flex justify-center items-center group-hover:hidden"
                  >
                    {{ notificationCount }}
                  </div>
                  <!-- 通知紅點 -->
                </div>

                <svg
                  v-if="currentMenuIndex === idx && isShowContent"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="10"
                  viewBox="0 0 14 10"
                  fill="none"
                >
                  <path
                    d="M7.51832 1.16969L13.4522 7.10356C13.7384 7.38974 13.7384 7.85372 13.4522 8.13988L12.7601 8.83197C12.4744 9.11767 12.0114 9.11821 11.725 8.83319L7.00015 4.1305L2.27532 8.83322C1.98896 9.11825 1.52592 9.1177 1.24023 8.832L0.548135 8.13991C0.26195 7.85372 0.26195 7.38974 0.548135 7.10359L6.482 1.16972C6.76816 0.883535 7.23214 0.883536 7.51832 1.16969Z"
                    :fill="
                      currentMenuIndex === idx && isShowContent
                        ? '#FF7E40'
                        : '#333333'
                    "
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="10"
                  viewBox="0 0 14 10"
                  fill="none"
                >
                  <path
                    d="M6.482 8.83202L0.548135 2.89812C0.26195 2.61193 0.26195 2.14796 0.548135 1.8618L1.24023 1.16971C1.52592 0.884013 1.98896 0.883463 2.27532 1.16849L7.00018 5.87121L11.725 1.16849C12.0114 0.883463 12.4744 0.884013 12.7601 1.16971L13.4522 1.8618C13.7384 2.14799 13.7384 2.61197 13.4522 2.89812L7.51835 8.83202C7.23217 9.11817 6.76819 9.11817 6.482 8.83202Z"
                    fill="#333333"
                  />
                </svg>
              </div>
              <div
                class="relative overflow-hidden transition-all max-h-0 duration-150 bg-new-gray-200"
                :style="`max-height:${
                  currentMenuIndex === idx && isShowContent
                    ? $refs.content[idx].scrollHeight
                    : 0
                }px`"
                ref="content"
              >
                <div
                  v-for="(menu, indx) in mobileNav.menus"
                  :key="'mobileMenu' + indx"
                  :class="['px-4 py-2', { 'first:pt-4': menu.title }]"
                >
                  <a
                    v-if="menu.title"
                    :href="!menu.link ? 'javascript:void(0)' : menu.link"
                    :class="[
                      'text-new-gray-800 font-bold inline-block',
                      menu.link
                        ? 'hover:text-new-primary-400'
                        : 'cursor-default',
                    ]"
                    @click="!menu.link ? '' : closeMenu"
                  >
                    {{ menu.title }}
                  </a>
                  <div
                    :class="[
                      'text-sm grid gap-4 my-2',
                      { 'grid-rows-4 grid-flow-col': menu.subMenus.length > 4 },
                    ]"
                  >
                    <a
                      v-for="(subMenus, id) in menu.subMenus"
                      :key="'mobileSubMenus' + id"
                      class="whitespace-nowrap flex"
                      :href="
                        subMenus.isHtml && !subMenus.link
                          ? 'javascript:void(0)'
                          : subMenus.link
                      "
                      :target="subMenus.target"
                      @click="
                        subMenus.isHtml ? openForeignAlert(idx) : closeMenu()
                      "
                    >
                      <div v-if="subMenus.isHtml">
                        <!-- label 只來自本元件內寫死的字串（開啟外幣功能＋foreignAccountStatusDesc 的三種固定標記），不含外部輸入 -->
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="subMenus.label"></div>
                      </div>
                      <div
                        v-else
                        :class="[
                          'text-new-gray-700 hover:text-new-primary-400 flex items-center',
                          { 'px-4': id < 4 && menu.title },
                          subMenus.textColor,
                        ]"
                      >
                        <div
                          v-if="
                            subMenus.iconName &&
                            subMenus.iconName === 'ellipsis-solid'
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="22"
                            width="22"
                            viewBox="0 0 512 512"
                            :class="[
                              'fill-new-gray-700 mr-1 group-hover:fill-new-primary-400',
                            ]"
                          >
                            <path
                              fill="currentColor"
                              d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                            />
                          </svg>
                        </div>

                        <img
                          v-if="
                            subMenus.iconName &&
                            subMenus.iconName !== 'ellipsis-solid'
                          "
                          :src="
                            require(`@/assets/images/${subMenus.iconName}.svg`)
                          "
                          :alt="subMenus.iconName"
                          class="mr-1"
                        />

                        <div class="flex justify-start items-center">
                          <img
                            src="@/assets/images/devil.svg"
                            v-if="subMenus.icon"
                            class="mr-2"
                            alt="devil"
                          />
                          {{ subMenus.label }}
                        </div>
                        <div
                          v-if="subMenus.suffix"
                          class="text-sm transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
                        >
                          {{ subMenus.suffix }}
                        </div>
                        <!-- 通知紅點 -->
                        <div
                          v-if="subMenus.label === '通知中心'"
                          class="h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 ml-2 flex justify-center items-center group-hover:hidden"
                        >
                          {{ notificationCount }}
                        </div>
                        <!-- 通知紅點 -->
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </a>
          </nav>
          <div class="fixed bottom-0 w-full max-w-[20rem] px-4 py-2 bg-white">
            <button
              v-if="!isLoggedIn"
              class="text-white font-medium bg-new-primary-500 px-4 py-2 rounded focus:outline-none w-full mb-2"
              @click="toRegisterPage"
            >
              開戶(含 TISA)
            </button>
            <button
              v-if="isLoggedIn"
              class="bg-white text-new-gray-800 font-medium ring-1 ring-new-gray-300 px-4 py-[7px] rounded hover:cursor-pointer focus:outline-none w-full"
              @click="toLogout"
            >
              登出
            </button>
            <button
              v-if="!isLoggedIn"
              class="bg-white text-new-gray-800 font-medium ring-1 ring-new-gray-300 px-4 py-[7px] rounded hover:cursor-pointer focus:outline-none w-full"
              @click="toLoginPage"
            >
              登入
            </button>
          </div>
          <!-- Mobile Navs Model end -->
        </div>
      </div>
    </div>
    <transaction-failed-notification
      v-if="isLoggedIn"
    ></transaction-failed-notification>

    <alert-modal v-model="isShowForeignAlert">
      <div class="text-new-gray-800 text-lg font-bold my-4">
        <div>[外幣開戶]</div>
        <div>補件通知</div>
      </div>

      <div class="w-14 h-14 mx-auto my-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="#FFD4C0"
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
          />
        </svg>
      </div>

      <div class="text-sm text-new-gray-700 my-4">
        <div>因您的證件有變更，請補件：</div>
        <div>更新存摺、身份證</div>
      </div>

      <div class="flex gap-2">
        <button
          class="bg-white border text-new-gray-800 text-lg font-bold w-full p-2 rounded"
          @click="isShowForeignAlert = false"
        >
          取消
        </button>

        <button
          class="bg-new-primary-500 text-lg text-white font-bold w-full p-2 rounded"
          @click="toForeignApplyPage"
        >
          進行補件
        </button>
      </div>
    </alert-modal>

    <alert-modal v-model="isShowForeignSubmittedAlert">
      <div class="text-new-gray-800 text-lg font-bold my-4">
        <div>[外幣開戶]</div>
        <div>正在審核中</div>
      </div>

      <div class="w-14 h-14 mx-auto my-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="#FFD4C0"
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
          />
        </svg>
      </div>

      <div class="text-sm text-new-gray-700 my-4">
        開啟後，將會 Email 通知您
      </div>

      <button
        class="bg-new-primary-500 text-lg text-white font-bold w-full p-2 rounded"
        @click="isShowForeignSubmittedAlert = false"
      >
        我知道了
      </button>
    </alert-modal>
  </div>
</template>

<script>
// Noto Sans TC 400／500／700 由本站提供（取代原本 <style> 內的 Google Fonts @import）。
// WordPress 頁面以 <link> 在 document 層載入 TheNavbar.css，整頁的 Noto Sans TC 都靠這裡的 @font-face，
// 因此只有 Vue 2 導覽列帶字型；建置後字型檔輸出在 dist/TheNavbar/fonts/，只保留 woff2
// （見 vue.config.js 與 scripts/build/postcss-fontsource-woff2-only.js）。
import "@fontsource/noto-sans-tc/400.css";
import "@fontsource/noto-sans-tc/500.css";
import "@fontsource/noto-sans-tc/700.css";
import TransactionFailedNotification from "./FailedNotification.vue";
import AlertModal from "./AlertModal.vue";

export default {
  name: "TheNavbar",
  props: {
    apiBaseUrl: {
      type: String,
      default: () => "/trade/api",
    },
  },
  components: {
    TransactionFailedNotification,
    AlertModal,
  },
  data() {
    return {
      isOpenMenu: false,
      navs: [
        // {
        //   title: '精選',
        //   menus: [
        //     {
        //       title: '投資資訊統計',
        //       link: '/trade/',
        //       subMenus: [
        //         {
        //           label: 'ETF 專區',
        //           link: '/trade?parent=excellent&ref=ETF',
        //         },
        //         {
        //           label: '買好股',
        //           link: '/trade?parent=excellent&ref=stock',
        //         },
        //         {
        //           label: '選好債',
        //           link: '/trade?parent=excellent&ref=bond',
        //         },
        //         {
        //           label: '基金品牌',
        //           link: '/trade?parent=fundBrand&ref=brand',
        //         },
        //         {
        //           label: '國人持有',
        //           link: '/trade?parent=ranking&ref=top',
        //         },
        //         {
        //           label: '獲獎基金',
        //           link: '/trade?parent=ranking&ref=excellent',
        //         },
        //         {
        //           label: '全球布局',
        //           link: '/trade?parent=parentGlobal&ref=global',
        //         },
        //         {
        //           label: '產業動態',
        //           link: '/trade?parent=parentIndustry&ref=industry',
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          title: "找基金",
          menus: [
            {
              title: "基金搜尋",
              link: "/trade/funds/",
              subMenus: [
                {
                  label: "快速交換基金",
                  link: "/trade/funds/?fundsIndex=1&exchangeInTradable=true",
                },
                {
                  label: "配息基金",
                  link: "/trade/funds/?filterType=dividend&tradable=true&s=-dividendAnnualRateOfReturn&page=1&dividendFrequency=半年配息|季配息|年配息|月配息|未固定配息",
                },
                {
                  label: "TISA 基金(退休)",
                  link: "/trade/funds/?fundsIndex=1&filterType=rateOfReturn&tradable=true&s=-rateOfReturn3Months&page=1&topics=TISA適格(退休)&tradingCurrency=美元%7C新台幣%7C歐元",
                  textColor: "text-new-red-500",
                },
                {
                  label: "基金照妖鏡",
                  link: "/trade/funds/?fundsIndex=2&filterType=rateOfReturn&tradable=true&s=-rateOfReturn3Months&page=1",
                  icon: "devil",
                },
              ],
            },
            {
              title: "投資資訊統計",
              link: "/trade/",
              subMenus: [
                {
                  label: "ETF 專區",
                  link: "/trade?parent=excellent&ref=ETF",
                },
                {
                  label: "買好股",
                  link: "/trade?parent=excellent&ref=stock",
                },
                {
                  label: "選好債",
                  link: "/trade?parent=excellent&ref=bond",
                },
                {
                  label: "基金品牌",
                  link: "/trade?parent=fundBrand&ref=brand",
                },
                {
                  label: "國人持有",
                  link: "/trade?parent=ranking&ref=top",
                },
                {
                  label: "獲獎基金",
                  link: "/trade?parent=ranking&ref=excellent",
                },
                {
                  label: "全球布局",
                  link: "/trade?parent=parentGlobal&ref=global",
                },
                {
                  label: "產業動態",
                  link: "/trade?parent=parentIndustry&ref=industry",
                },
              ],
            },
            {
              title: "本土投信",
              link: "/trade/funds/?filterType=rateOfReturn&tradable=true&page=1&fundArea=境內",
              subMenus: [
                {
                  label: "野村投信",
                  link: "/fund-brand/Nomura/",
                },
                {
                  label: "國泰投信",
                  link: "/fund-brand/Cathay/",
                },
                {
                  label: "兆豐投信",
                  link: "/fund-brand/MegaBank/",
                },
                {
                  label: "瀚亞投信",
                  link: "/fund-brand/eastspring/",
                },
                {
                  label: "統一投信",
                  link: "/fund-brand/ezmoney/",
                },
                {
                  label: "群益投信",
                  link: "/fund-brand/Capital/",
                },
                {
                  label: "復華投信",
                  link: "/fund-brand/FHTrust/",
                },
                {
                  label: "......更多",
                  link: "/fund-brand/",
                  // iconName: 'ellipsis-solid',
                },
              ],
            },
            {
              title: "國外品牌",
              link: "/trade/funds/?filterType=rateOfReturn&tradable=true&page=1&fundArea=境外",
              subMenus: [
                {
                  label: "貝萊德 BlackRock",
                  link: "/fund-brand/BlackRock/",
                },
                {
                  label: "安聯投信",
                  link: "/fund-brand/Allianz/",
                },
                {
                  label: "摩根 J.P. Morgan",
                  link: "/fund-brand/JPMorgan/",
                },
                {
                  label: "高盛(原NNL) GS",
                  link: "/fund-brand/GoldmanSachs/",
                },
                {
                  label: "富達 Fidelity",
                  link: "/fund-brand/Fidelity/",
                },
                {
                  label: "景順 Invesco",
                  link: "/fund-brand/Invesco/",
                },
                {
                  label: "施羅德 Schroders ",
                  link: "/fund-brand/Schroders/",
                },
                {
                  label: "......更多",
                  link: "/fund-brand/",
                  // iconName: 'ellipsis-solid',
                },
              ],
            },
          ],
        },
        {
          title: "優惠",
          menus: [
            {
              title: "最新活動",
              link: "/campaign/",
              subMenus: [
                {
                  label: "TISA 專案(退休)",
                  link: "/retirement/",
                  target: "_self",
                  suffix: "new",
                },
                {
                  label: "電支雞享10%回饋",
                  link: "/events/px-10percent/",
                  target: "_self",
                },
                {
                  label: "這 mo 好康",
                  link: "/campaign/campaign-double-gift-account/?coupon-fs888",
                  target: "_self",
                },
                {
                  label: "一「定」免費",
                  link: "/campaign/sip-0-fee",
                  target: "_self",
                },
                {
                  label: "......更多",
                  link: "/campaign/",
                  target: "_self",
                },
              ],
            },
          ],
          suffix: "hot",
        },
        {
          title: "教學/FAQ",
          menus: [
            {
              title: "懶人包",
              link: "https://www.fundswap.com.tw/posts-index/categories/fund-services/",
              target: "_self",
              subMenus: [
                {
                  label: "5 分鐘線上開戶",
                  link: "https://www.fundswap.com.tw/faqs/%e2%80%bb%e9%96%8b%e6%88%b6%e6%95%99%e5%ad%b8-%e7%b6%b2%e8%b7%af%e9%8a%80%e8%a1%8c%e6%99%b6%e7%89%87%e9%87%91%e8%9e%8d%e5%8d%a1/",
                  target: "_self",
                },
                {
                  label: "綁定台幣扣款",
                  link: "https://www.fundswap.com.tw/faqs/%e7%94%b3%e8%ab%8b%e9%96%8b%e6%88%b6%ef%bc%8c%e6%89%a3%e6%ac%be%e9%87%91%e8%9e%8d%e6%a9%9f%e6%a7%8b%e6%9c%89%e5%93%aa%e4%ba%9b%ef%bc%9f/",
                  target: "_self",
                },
                {
                  label: "手機桌面 APP 圖示",
                  link: "https://www.fundswap.com.tw/faqs/%e7%b6%b2%e9%a0%81%e7%a7%92%e8%ae%8a-app-%e5%9c%96%e7%a4%ba-iphone%e7%af%87/",
                  target: "_self",
                },
                {
                  label: "電支雞懶人包",
                  link: "/posts-index/fund-news/pxfund-tutorial/",
                },
              ],
            },
            {
              title: "常見問題",
              link: "https://www.fundswap.com.tw/faqs/",
              subMenus: [
                {
                  label: "單筆申購、贖回",
                  link: "https://www.fundswap.com.tw/faqs/%e5%9f%ba%e9%87%91%e7%94%b3%e8%b3%bc-%e8%b4%96%e5%9b%9e%e5%be%8c%ef%bc%8c%e9%a0%90%e4%bc%b0%e5%a4%9a%e4%b9%85%e5%85%a5%e5%b8%b3%ef%bc%9f%e6%b7%a8%e5%80%bc%e9%81%a9%e7%94%a8%ef%bc%9f%e5%a6%82%e4%bd%95/",
                  target: "_self",
                },
                {
                  label: "定期定額投資",
                  link: "https://www.fundswap.com.tw/faqs/%e5%a6%82%e4%bd%95%e8%a8%ad%e5%ae%9a%e5%ae%9a%e6%9c%9f%e5%ae%9a%e9%a1%8d%e5%a5%91%e7%b4%84%ef%bc%9f/",
                  target: "_self",
                },
                {
                  label: "基金交換特色",
                  link: "https://www.fundswap.com.tw/faqs/%e4%bb%80%e9%ba%bc%e6%98%af%e5%9f%ba%e9%87%91%e4%ba%a4%e6%8f%9b%ef%bc%9f%e4%ba%a4%e6%98%93%e7%89%b9%e8%89%b2%ef%bc%9f/",
                  target: "_self",
                },
                {
                  label: "牌告收費標準",
                  link: "https://www.fundswap.com.tw/faqs/%e6%94%b6%e8%b2%bb-%e5%8c%af%e7%8e%87-%e5%88%a9%e7%8e%87%e7%89%8c%e5%91%8a/",
                  target: "_self",
                },
                {
                  label: "開戶補件",
                  link: "https://www.fundswap.com.tw/faqs/%E9%96%8B%E6%88%B6%E8%A3%9C%E4%BB%B6%E5%8E%9F%E5%9B%A0%EF%BC%9F%E5%A6%82%E4%BD%95%E8%A3%9C%E4%BB%B6%EF%BC%9F/",
                  target: "_self",
                },
                {
                  label: "開啟外幣功能",
                  link: "https://www.fundswap.com.tw/faqs/%E5%A6%82%E4%BD%95%E3%80%8C%E5%8A%A0%E9%96%8B%E5%A4%96%E5%B9%A3%E5%B8%B3%E6%88%B6%E3%80%8D%E6%89%A3%E6%AC%BE%EF%BC%9F%E6%9C%89%E5%93%AA%E4%BA%9B%E6%89%A3%E6%AC%BE%E9%8A%80%E8%A1%8C%EF%BC%9F/",
                  target: "_self",
                },
                {
                  label: "電支雞扣款常見問題",
                  link: "https://www.fundswap.com.tw/faqs/q_electric_chicken_deduction_failure/",
                  target: "_self",
                },
                {
                  label: "......更多",
                  link: "https://www.fundswap.com.tw/faqs/",
                  target: "_self",
                },
              ],
            },
          ],
        },
        {
          title: "投資分析",
          menus: [
            {
              title: "知識庫",
              link: "/posts-index/",
              subMenus: [
                {
                  label: "服務介紹",
                  link: "/posts-index/categories/fund-services/",
                },
                {
                  label: "投信觀點",
                  link: "/posts-index/categories/fund-house-view/",
                },
                {
                  label: "基金知識",
                  link: "/posts-index/categories/fund-knowledge/",
                },
                {
                  label: "退休理財",
                  link: "/posts-index/categories/retirement-planning/",
                },
              ],
            },
            {
              title: "焦點強棒",
              link: "/trade/funds/?filterType=rateOfReturn&tradable=true&majorFund=true&s=-rateOfReturn3Months&page=1&series=滙豐%7C野村%7C貝萊德%7C安聯投信%7C景順%7C摩根%7C富達%7C中國信託%7C台中銀%7C先機%7C法盛%7C施羅德%7C晉達%7C紐約梅隆%7C高盛%28原NNL%29%7C瑞聯%7C駿利亨德森%7C聯邦%7C華南永昌%7CGAM%7C新加坡大華%7C宏利%7C路博邁&investmentTarget=債券型%7C股票型&currency=美元&fundScale=3000.0&dividendFrequency=不配息&riskLevel=3%7C4%7C5",
              subMenus: [
                {
                  label: "基金怎麼選？",
                  link: "/posts-index/fund-knowledge/teaching20250211/",
                },
                {
                  label: "認識基金種類",
                  link: "/posts-index/fund-knowledge/how-mutual-fund/",
                },
                {
                  label: "掌握降息契機",
                  link: "/posts-index/fund-knowledge/interestrates20240916/",
                },
                {
                  label: "TISA是什麼？",
                  link: "/posts-index/retirement-planning/tisa20250527/",
                },
              ],
            },
          ],
        },
        {
          title: "客服",
          menus: [
            {
              title: "關於我們",
              link: "/aboutfundswap/",
              subMenus: [
                {
                  label: "認識好好",
                  link: "/aboutfundswap/",
                },
                {
                  label: "公告訊息",
                  link: "/trade/announcements/",
                },
                {
                  label: "聯絡客服",
                  link: "https://www.fundswap.com.tw/faqs/%e9%9c%80%e5%8d%94%e5%8a%a9%ef%bc%8c%e5%a6%82%e4%bd%95%e6%89%be%e5%88%b0%e5%a5%bd%e5%a5%bd%e5%ae%a2%e6%9c%8d%ef%bc%9f/",
                  target: "_self",
                  iconName: "comments-solid",
                  textColor: "text-new-primary-500",
                },
              ],
            },
          ],
        },
      ],
      isShowContent: false,
      currentMenuIndex: 0,
      isTenantLoggedIn: false,
      notificationCount: 0,
      condition: true,
      tenantStatus: null,
      isShowForeignAlert: false,
      isShowForeignSubmittedAlert: false,
      tenantAccountStatus: null,
    };
  },
  computed: {
    isLoggedIn() {
      return this.isTenantLoggedIn;
    },
    subNavs() {
      let navs = [
        {
          title: "庫存/紀錄",
          menus: [
            {
              title: "我的基金",
              link: "/trade/inventory/funds/",
              subMenus: [
                {
                  label: "基金庫存",
                  link: "/trade/inventory/funds/",
                },
                {
                  label: "交易紀錄",
                  link: "/trade/transactions/",
                },
                {
                  label: "交易委託中",
                  link: "/trade/transactions/?status=pending,canceled",
                },
                {
                  label: "定期定額契約",
                  link: "/trade/transactions/sip/",
                },
                {
                  label: "月對帳單",
                  link: "/trade/member-center/statements/",
                },
              ],
            },
            // {
            //   title: '交易紀錄',
            //   link: '/trade/transactions/',
            //   subMenus: [
            //     {
            //       label: '交易委託中',
            //       link: '/trade/transactions/?status=pending,canceled',
            //     },
            //     {
            //       label: '定期定額契約',
            //       link: '/trade/transactions/sip/',
            //     },
            //     {
            //       label: '基金比較',
            //       link: '/trade/funds-compare/?mfxID=ARBB,JP64,FD56,IVB5,LAAO',
            //       iconName: 'plus-solid',
            //       textColor: 'text-new-primary-500',
            //     },
            //   ],
            // },
          ],
        },
        {
          title: "信託分戶帳(錢包)",
          // link: '/trade/member-center/wallet/',
          menus: [
            {
              title: "我的錢包",
              link: "/trade/member-center/wallet/",
              subMenus: [
                {
                  label: "帳戶餘額",
                  link: "/trade/member-center/wallet/",
                },
                {
                  label: "交易紀錄",
                  link: "/trade/member-center/ledger/",
                },
              ],
            },
          ],
        },
      ];

      let tenantSubnavs = [
        {
          title: "帳戶相關",
          menus: [
            {
              title: "我的",
              link: "/trade/member-center/",
              subMenus: [
                {
                  label: "會員中心",
                  link: "/trade/member-center/",
                },
                ...(this.tenantStatus &&
                this.tenantStatus.openingStatus === "passed"
                  ? [
                      {
                        label: "修改風險屬性",
                        link: "/trade/member-center/risk-level-questionnaire/",
                      },
                    ]
                  : []),
                ...(this.isApplyForeignAccountAvailable
                  ? [
                      {
                        label: `<div class="text-new-gray-700 hover:text-new-primary-400 ml-4 xl:ml-0 flex flex-col items-start">開啟外幣功能<div class="w-32 whitespace-pre-wrap text-sm">${this.foreignAccountStatusDesc}</div></div>`,
                        link: this.isForeignAccountStatusNotApplied
                          ? "/trade/member-center/apply-foreign-account/"
                          : "",
                        isHtml: true,
                      },
                    ]
                  : []),
                ...(this.isAccountOpening
                  ? [
                      {
                        label: "開戶進度/線上補件",
                        link:
                          (this.tenantStatus &&
                            this.tenantStatus.openingStatus ===
                              "not-applied") ||
                          (this.tenantStatus &&
                            this.tenantStatus.openingStatus ===
                              "account-opening")
                            ? "/trade/member-center/open-account/"
                            : `/trade${
                                this.tenantStatus &&
                                this.tenantStatus.accountOpenLink
                              }`,
                        iconName: "address-card-solid",
                        textColor: "text-new-primary-500",
                      },
                    ]
                  : []),
              ],
            },
            {
              title: "設定",
              link: "/trade/member-center/",
              subMenus: [
                {
                  label: "我的追蹤",
                  link: "/trade/funds/?fundsIndex=1&filterType=rateOfReturn&s=-rateOfReturn3Months&inFavorites=true&page=1",
                },
                {
                  label: "變更密碼",
                  link: "/trade/member-center/change-password/",
                },
                {
                  label: "快速驗證",
                  link: "/trade/member-center/webauthn-devices/",
                },
              ],
            },
          ],
        },
      ];

      return this.isLoggedIn ? [...navs, ...tenantSubnavs] : navs;
    },
    mobileNavs() {
      return [
        ...this.navs.slice(0, 2), // 取出前兩個元素
        ...this.subNavs, // 插入 subNavs
        ...this.navs.slice(2), // 取出剩餘的元素
      ];
    },
    isAccountOpening() {
      return [
        "not-applied",
        "account-opening",
        "reservation-secondary-auth-needed",
        "additional-doc-needed",
        "secondary-reauth-needed",
        "primary-reauth-needed",
        "both-reauth-needed",
        "personal-info-error",
        "deduction-needed",
      ].includes(this.tenantStatus && this.tenantStatus.openingStatus);
    },
    isApplyForeignAccountAvailable() {
      const status = this.tenantAccountStatus?.foreignCurrencyAccount?.status;
      return status && status !== "passed";
    },
    isForeignAccountStatusNotApplied() {
      let status = this.tenantStatus && this.tenantStatus.foreignCurrencyStatus;
      return (
        status === "not-applied" ||
        status === "reject" ||
        status === "fail" ||
        status === "expired" ||
        status === "cancel"
      );
    },
    isForeignAccountStatusAdditionalDocNeeded() {
      let status = this.tenantStatus && this.tenantStatus.foreignCurrencyStatus;
      return status === "additional-doc-needed";
    },
    isForeignAccountStatusSubmitted() {
      let status = this.tenantStatus && this.tenantStatus.foreignCurrencyStatus;
      return (
        status === "request" ||
        status === "request-call-out" ||
        status === "prepare-send-tdcc" ||
        status === "send-tdcc-debit-authorization" ||
        status === "received-tdcc" ||
        status === "send-tdcc-customer" ||
        status === "send-tdcc"
      );
    },
    foreignAccountStatusDesc() {
      return this.isForeignAccountStatusNotApplied
        ? '<span class="fs-foreign-not-applied">尚未開通</span>'
        : this.isForeignAccountStatusAdditionalDocNeeded
        ? '<div class="fs-foreign-additional-doc-needed"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16"><path fill="#FA3130" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg></svg>待補件</div>'
        : '<div class="fs-foreign-submitted"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16"><path fill="#999999" d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>審核中</div>';
    },
  },
  watch: {
    isOpenMenu: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            // this.currentMenuIndex = 0;
            // this.isShowContent = true;
            this.$emit("toggle-mobile-menu", true);
            document.querySelector("html").classList.add("fixed-bg-modal");
          });
        } else {
          document.querySelector("html").classList.remove("fixed-bg-modal");
          this.isShowContent = false;
        }
      },
    },
    isLoggedIn: {
      immediate: true,
      handler() {
        this.fetchTenantStatus();
        // this.fetchNoticeCount();
      },
    },
  },
  methods: {
    async toLogout() {
      await fetch(`${this.apiBaseUrl}/sign-out`, {
        method: "POST",
        credentials: "include",
      });
      this.fetchTenantStatus();
      this.closeMenu();
    },
    toLoginPage() {
      window.location = "/trade/login";
      history.pushState({}, "", "/trade/login");
      this.closeMenu();
    },
    toRegisterPage() {
      window.location = "/trade/signup";
      history.pushState({}, "", "/trade/signup");
      this.closeMenu();
    },
    toggle(idx) {
      if (this.currentMenuIndex === idx) {
        this.isShowContent = !this.isShowContent;
      } else {
        this.isShowContent = true;
      }
      this.currentMenuIndex = idx;
    },
    async fetchTenantStatus() {
      try {
        const [statusResponse, accountStatusResponse] = await Promise.all([
          fetch(`${this.apiBaseUrl}/tenant/status`, {
            credentials: "include",
          }),
          fetch(`${this.apiBaseUrl}/tenant/account-status`, {
            credentials: "include",
          }),
        ]);

        if (statusResponse.status === 200) {
          this.isTenantLoggedIn = true;
          const data = await statusResponse.json();
          this.tenantStatus = data.data;
        } else {
          this.isTenantLoggedIn = false;
        }

        if (accountStatusResponse.status === 200) {
          const data = await accountStatusResponse.json();
          this.tenantAccountStatus = data.data;
        }
      } catch (error) {
        console.error("Failed to fetch tenant data:", error);
        this.isTenantLoggedIn = false;
      }
    },
    closeMenu() {
      this.isOpenMenu = false;
      this.isShowContent = false;
      document.querySelector("html").classList.remove("fixed-bg-modal");
    },
    goWordPressIndex() {
      window.location = window.origin;
    },
    async fetchNoticeCount() {
      const response = await fetch(
        `${this.apiBaseUrl}/tenant/notification/count`,
        { credentials: "include" }
      );
      if (response.status === 200) {
        const data = await response.json();
        this.notificationCount =
          data.data &&
          data.data.personalNotificationCount +
            data.data.systemNotificationCount;
      } else {
        this.notificationCount = 0;
      }
    },
    openForeignAlert(index) {
      if (index) this.toggle(index);

      if (this.isForeignAccountStatusAdditionalDocNeeded) {
        this.isShowForeignAlert = true;
      }
      if (this.isForeignAccountStatusSubmitted) {
        this.isShowForeignSubmittedAlert = true;
      }
    },
    toForeignApplyPage() {
      this.isShowForeignAlert = false;
      this.closeMenu();

      window.location = "/trade/member-center/apply-foreign-account";
      history.pushState({}, "", "/trade/member-center/apply-foreign-account");
    },
  },
  mounted() {
    this.fetchTenantStatus();

    window.addEventListener("resize", this.closeMenu);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.closeMenu);
  },
};
</script>

<style>
.fixed-bg-modal {
  height: 100%;
  overflow: hidden !important;
}
.fs-foreign-manu-nav-link {
  color: #666666; /* Tailwind's text-new-gray-700 */
  margin-left: 1rem; /* Tailwind's ml-4 */
  display: flex; /* Tailwind's flex */
  align-items: center; /* Tailwind's items-center */
}

.fs-foreign-manu-nav-link:hover {
  color: #ffab83; /* Tailwind's hover:text-new-primary-400 */
}

@media (min-width: 1280px) {
  /* Tailwind's xl:ml-0 */
  .fs-foreign-manu-nav-link {
    margin-left: 0;
  }
}

.fs-foreign-not-applied {
  color: #fa3130; /* Tailwind's text-new-red-500 */
  margin-left: 0.5rem; /* Tailwind's ml-2 */
}

.fs-foreign-additional-doc-needed {
  color: #fa3130; /* Tailwind's text-new-red-500 */
  display: inline-flex; /* Tailwind's inline-flex */
  justify-content: space-between; /* Tailwind's justify-between */
  align-items: center; /* Tailwind's items-center */
  margin-left: 0.5rem; /* Tailwind's ml-2 */
  width: 4rem; /* Tailwind's w-16 */
}

.fs-foreign-submitted {
  color: #999999; /* Tailwind's text-new-gray-600 */
  display: inline-flex; /* Tailwind's inline-flex */
  justify-content: space-between; /* Tailwind's justify-between */
  align-items: center; /* Tailwind's items-center */
  margin-left: 0.5rem; /* Tailwind's ml-2 */
  width: 4rem; /* Tailwind's w-16 */
}
</style>

<style lang="scss" scoped>
@use "tailwindcss/base" as base;
@use "tailwindcss/components" as components;
@use "tailwindcss/utilities" as utilities;

// Noto Sans TC 由本站提供：見 <script> 開頭的 @fontsource/noto-sans-tc import。
// 不再 @import fonts.googleapis.com（Google Fonts 的 CSS 會變動、無法加 SRI，2026 資安健診 #32）。

.fs-the-navbar {
  font-family: "Noto Sans TC", Microsoft JhengHei, 微軟正黑體;
}
</style>
